import script from "./CustomListMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomListMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CustomListMenu.vue?vue&type=style&index=0&id=5f99e906&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f99e906"]])

export default __exports__